import { useEffect, useState } from 'react';
import { useEditorContext } from './useEditorContext';

enum DomDataIds {
  USER_HOMEWORK_HELP_REQUEST = 'js_data_user_homework_help_request',
  USER_HOMEWORK_HELP_SUBJECT = 'js_data_user_homework_help_subject',
  USER_HOMEWORK_HELP_TEXT_FROM_FILES = 'js_data_user_homework_help_text_from_files',
}

const getElementTextContent = (id: string): string => {
  const element = document.getElementById(id);
  return element?.textContent?.trim() || '';
};

const parseJsonFromElement = <T>(id: string, fallback: T): T => {
  const element = document.getElementById(id);
  const textContent = element?.textContent?.trim();

  if (!textContent) {
    return fallback;
  }

  try {
    return JSON.parse(textContent) as T;
  } catch {
    return fallback;
  }
};

export const useEditorDomData = () => {
  const [isDomDataLoaded, setIsDomDataLoaded] = useState(false);
  const { EditorActionCreator, editorDispatch } = useEditorContext();

  useEffect(() => {
    if (isDomDataLoaded) {
      return;
    }

    const request = getElementTextContent(
      DomDataIds.USER_HOMEWORK_HELP_REQUEST
    );
    const subject = getElementTextContent(
      DomDataIds.USER_HOMEWORK_HELP_SUBJECT
    );
    const textFromFiles = parseJsonFromElement<string[]>(
      DomDataIds.USER_HOMEWORK_HELP_TEXT_FROM_FILES,
      []
    );

    const hasData = request || subject || textFromFiles.length > 0;

    // eslint-disable-next-line no-console
    console.log('editor incoming data', { request, subject, textFromFiles });
    if (hasData) {
      editorDispatch(EditorActionCreator.setUserHomeworkHelpRequest(request));
      editorDispatch(EditorActionCreator.setUserHomeworkHelpSubject(subject));
      editorDispatch(
        EditorActionCreator.setUserHomeworkHelpTextFromFiles(textFromFiles)
      );
    }

    setIsDomDataLoaded(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isDomDataLoaded };
};
